import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import service from '../../services/service'
import endpoints from '../../services/endpoints'

const WishlistJoin = () => {
    const navigate = useNavigate()
    const { token } = useParams()
    const [failed, setFailed] = useState(false)

    useEffect(() => {
        if (!token) {
            setFailed(true)
            return
        }
        service
            .post(endpoints.wishlists.join.replace('{token}', token), {})
            .then(({ data }) => {
                const id = data.data?.id
                navigate(id ? `/wishlist-detail?id=${id}` : '/wishlist', { replace: true })
            })
            .catch(() => setFailed(true))
    }, [token, navigate])

    if (failed) {
        return (
            <section className='allSearchArea commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <p className='fare-extra-hint'>This invite link is invalid or has expired.</p>
                    <button type='button' className='commonBtn' onClick={() => navigate('/wishlist')}>Go to Wishlists</button>
                </div>
            </section>
        )
    }

    return (
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <p className='fare-extra-hint'>Joining wishlist...</p>
            </div>
        </section>
    )
}

export default WishlistJoin
